import React from 'react';
import { View, StyleSheet } from 'react-native';
import ViewShot from 'react-native-view-shot';
import Style from '../../../constants/Style';
import WidgetHeader from './WidgetHeader';
import LineGraph from '../../../graphs/LineGraph';
import isMobile from '../../../components/IsMobile';
import LineGraphMobile from '../../../graphs/LineGraphMobile';
import { SolveAnalyticsWidgetProps } from '../Utils';

const SLAViolationsGraph = ({
  range, compareRange, viewShotRef, data, comparisonData,
}: SolveAnalyticsWidgetProps) => <View style={Style.commonCardStyle}>
    <WidgetHeader
      title='SLA violations'
      {...{ range, compareRange }}
      tooltipText='Shows a graph of the number of tickets violating their SLA, per day'
    />
    <ViewShot ref={viewShotRef}>
      {isMobile ? <View style={styles.graphMobile}>
        <LineGraphMobile
          {...{ data }}
          comparisonData={(compareRange.start && compareRange.end) ? comparisonData : []}
        />
      </View> : <LineGraph
        title='Violations'
        noAxisLabel
        noTitle
        chartData={data}
        comparisonData={(compareRange.start && compareRange.end) ? comparisonData : null}
      />}
    </ViewShot>
  </View>;

const styles = StyleSheet.create({
  graphMobile: {
    aspectRatio: 1,
    marginStart: -24,
    marginEnd: 24,
  },
});

export default SLAViolationsGraph;
